import React, { Component } from "react";
import { Accessor, ColorX, ResponsiveX } from "IZOX/STATIC";
import { HStack, Spacer, VStack } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { observer } from "mobx-react";
import PDCMenu from "./_gears/PDCMenu";
import PDCPolicy from "./_gears/PDCPolicy";
import PDCNoti from "./_gears/PDCNoti";
import FooterM from "shared/FooterM";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PDCContainer extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDCContainer.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  renderNormal(){
    let {children} = this.props;
    return (
      <VStack fullWidth bgColor={ColorX.CSS("Grass")} pT={30} VAlign="^"
        minHeight={"100%"}>
        <HStack spacing={16} VAlign="^">
          <VStack width={157} spacing={16}>
            <PDCMenu/>
            <PDCPolicy/>
          </VStack> 
          <VStack width={848}>
            {children}
          </VStack>
          <VStack width={243} height={window.innerHeight}>
            <PDCNoti/>
          </VStack>   
        </HStack>
      </VStack>
    );
  }

  renderMobile(){
    let {children} = this.props;
    return (
      <VStack fullWidth bgColor={ColorX.CSS("Grass")} VAlign="^"
        minHeight={"100%"}>
        <VStack fullWidth p={16} spacing={16}>
          <VStack fullWidth>
            <PDCPolicy/>
          </VStack>
          <VStack fullWidth>
            <PDCMenu/>
          </VStack>
          <VStack fullWidth>
            {children}
          </VStack>
        </VStack>
        <Spacer/>
        <FooterM/>
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal(),
    });
  }

}

export default observer(PDCContainer);
